import { injectable, interfaces } from 'inversify';
import { IObservableArray, makeObservable, observable } from 'mobx';
import { IPreviewImageAttributes } from '../datasets/datasetsDetails.store';

export interface IAttachmentPreviewImageInfo {
  id: string;
  name: string;
  width: number;
  height: number;
  size: number;
  createdDate: string;
  parentId: string;
}

export interface IPreviewPaging {
  id: string;
  wasChanged: boolean;
  checkDate: string;
  items: IPreviewPagingItem[];
}

export interface IPreviewPagingItem {
  imageId: string;
  index: number;
  size: number;
}

export interface IAttachmentsPreviewStore {
  imageInfo: IAttachmentPreviewImageInfo;
  previewPaging: IPreviewPaging;
  isPreviewImageLoading: boolean;
  lowQualityImagePreviewUrl: string;
  imagePreviewUrl: string;
  activePreloads: IObservableArray<string>;
  imageAttributes: IPreviewImageAttributes;
}

export namespace IAttachmentsPreviewStore {
  export const $: interfaces.ServiceIdentifier<IAttachmentsPreviewStore> = Symbol('ATTACHMENTS_PREVIEW_STORE');
}

@injectable()
export class AttachmentsPreviewStore implements IAttachmentsPreviewStore {
  imageInfo: IAttachmentPreviewImageInfo = {
    createdDate: '',
    name: '',
    id: '',
    height: 0,
    width: 0,
    size: 0,
    parentId: '',
  };

  previewPaging: IPreviewPaging = {
    id: '',
    checkDate: '',
    items: [],
    wasChanged: true,
  };

  imageAttributes: IPreviewImageAttributes = {
    channels: 0,
    isCached: false,
    downloadSpeed: 0,
  };

  isPreviewImageLoading: boolean = false;

  lowQualityImagePreviewUrl: string = '';

  imagePreviewUrl: string = '';

  activePreloads: IObservableArray<string> = observable.array([]);

  constructor() {
    makeObservable(this, {
      imageInfo: observable,
      previewPaging: observable,
      imageAttributes: observable,
      isPreviewImageLoading: observable,
      lowQualityImagePreviewUrl: observable,
      imagePreviewUrl: observable,
      activePreloads: observable,
    });
  }
}
